import N from "classnames";
import { isValidElement as h } from "react";
import { container as f, flex as p, card as v, image as x, text as b, title as g, subtitle as u, profileChildren as E } from "./Profile.css.js";
import { jsx as e, jsxs as l } from "react/jsx-runtime";
function V(t) {
  const {
    element: s,
    children: m,
    className: c,
    attributes: r,
    imageElement: n
  } = t, {
    title: d,
    subtitle: o,
    customAttributes: i
  } = s, a = n || s.image;
  return /* @__PURE__ */ e("div", {
    ...i,
    className: N(c, f, i == null ? void 0 : i.className),
    ...r,
    children: /* @__PURE__ */ l("div", {
      className: p,
      children: [/* @__PURE__ */ l("div", {
        className: v,
        children: [h(a) && /* @__PURE__ */ e("div", {
          contentEditable: !1,
          className: x,
          children: a
        }), /* @__PURE__ */ l("div", {
          className: b,
          children: [/* @__PURE__ */ e("h1", {
            className: g,
            children: d
          }), /* @__PURE__ */ e("p", {
            className: u,
            children: o
          })]
        })]
      }), /* @__PURE__ */ e("div", {
        className: E,
        children: m
      })]
    })
  });
}
export {
  V as ProfileElement
};
